import {useEffect, useState} from 'react'
import {useBlocker, useLocation, useNavigate} from 'react-router'

export const useNavigationBlocker = (enabled = true) => {
  const navigate = useNavigate()
  const currentLocation = useLocation()

  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(true)
  const [isBlockActive, setIsBlockActive] = useState(true)
  const [nextLocation, setNextLocation] = useState('')

  const navigationBlocker = useBlocker(({currentLocation, nextLocation}) => {
    if (!enabled) return false
    setIsConfirmDialogOpen(true)
    setNextLocation(nextLocation.pathname)
    return isBlockActive && currentLocation.pathname !== nextLocation.pathname
  })

  const beforeUnloadHandler = (event: BeforeUnloadEvent) => {
    event.preventDefault()

    // Included for legacy support, e.g. Chrome/Edge < 119
    event.returnValue = true
  }

  const bypassNavigationBlocker = () => {
    setIsBlockActive(false)
    setIsConfirmDialogOpen(false)
    removeEventListener('beforeunload', beforeUnloadHandler)
  }

  useEffect(() => {
    if (!enabled) return
    addEventListener('beforeunload', beforeUnloadHandler)
    return () => {
      removeEventListener('beforeunload', beforeUnloadHandler)
    }
  }, [enabled])

  useEffect(() => {
    if (!enabled) return
    if (!isBlockActive && nextLocation !== currentLocation.pathname) {
      void navigate(nextLocation)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isBlockActive, enabled])

  return {
    isBlocked: enabled && navigationBlocker.state === 'blocked' && isConfirmDialogOpen,
    handleClose: () => setIsConfirmDialogOpen(false),
    setIsBlockActive,
    bypassNavigationBlocker
  }
}
